import IconKeys from "../../components/icons/IconKeys";
import IconButton from "../../components/icons/IconButton";
import IconSave from "../../components/icons/IconSave";
import IconVisibleOff from "../../components/icons/IconVisibleOff";
import IconRepair from "../../components/icons/IconRepair";
import ConnectorFormField from "./ConnectorFormField";
import IconAddLink from "../../components/icons/IconAddLink";
import WordLinkPickerPanel from "./WordLinkPickerPanel";

export default function ConnectorForm({ form, estimationGroups, stages }) {
    const {
        inputValue,
        isRightValue,
        pointValue,
        urlValue,
        connectorTypeChosen,
        addConnectorInfo,
        isVisibleChangeConnectorButton,
        connectorFormEntities,
        connectorConfig,
        wordValue,
        isWordPickerOpen,
        trigerConnectorConfig,
        visibilityConnectorFields,
        inputChangeHandler,
        choseConnectorHandler,
        checkboxConnectorHandler,
        selectEsGroupChangeHandler,
        selectStageChangeHandler,
        inputPointsChangeHandler,
        urlInputChangeHandler,
        toggleWordPicker,
        handleWordPicked,
        clearWordHandler,
        saveConnector,
    } = form;

    return (
        <div className={`add-answer-connector-container ${connectorConfig ? "header-open" : ""}`}>
            <div className="add-answer-connector-header">
                <div onClick={trigerConnectorConfig}>
                    <IconRepair fillColor="icon-blue" style={{ height: 20, width: 20 }} />
                </div>
            </div>

            <div>
                <div className="add-answer-connector-body">
                    <ConnectorFormField
                        fieldKey="title"
                        visible={connectorFormEntities.title.visible}
                        editing={connectorConfig}
                        label="Заголовок"
                        onToggleVisibility={visibilityConnectorFields}
                    >
                        <p className="form-element-conn">{addConnectorInfo}</p>
                    </ConnectorFormField>

                    <ConnectorFormField
                        fieldKey="text"
                        visible={connectorFormEntities.text.visible}
                        editing={connectorConfig}
                        label="Текст"
                        onToggleVisibility={visibilityConnectorFields}
                    >
                        <div className="connector-text-input-row form-element-conn">
                            <div className={"connector-text-input-wrap" + (wordValue ? " word-linked" : "")}>
                                <input
                                    className="answer-connector-text connector-text-input"
                                    value={inputValue}
                                    onChange={inputChangeHandler}
                                />
                                {wordValue ? (
                                    <span className="connector-text-word-clear" onClick={clearWordHandler} title="Відв'язати слово">
                                        ×
                                    </span>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className="connector-text-add-word-wrap">
                                <div
                                    className={"connector-text-add-word-btn" + (isWordPickerOpen ? " active" : "")}
                                    onClick={toggleWordPicker}
                                    onMouseDown={(e) => e.stopPropagation()}
                                    title="Прив'язати слово зі словника"
                                >
                                    <IconAddLink fillColor="icon-teel" style={{ height: 20, width: 20 }} />
                                </div>
                                <WordLinkPickerPanel isOpen={isWordPickerOpen} onSelect={handleWordPicked} />
                            </div>
                        </div>
                    </ConnectorFormField>

                    <ConnectorFormField
                        fieldKey="isRight"
                        visible={connectorFormEntities.isRight.visible}
                        editing={connectorConfig}
                        label="Вірність"
                        onToggleVisibility={visibilityConnectorFields}
                    >
                        <div className="checkbox-three-options form-element-conn">
                            <div
                                className={"checkbox-three-elem" + (isRightValue == 1 ? " right-chosen" : " ")}
                                onClick={() => checkboxConnectorHandler(1)}
                            >
                                <p>Вірна</p>
                            </div>
                            <div
                                className={"checkbox-three-elem" + (isRightValue == 2 ? " wrong-chosen" : " ")}
                                onClick={() => checkboxConnectorHandler(2)}
                            >
                                <p>Хибна</p>
                            </div>
                            <div
                                className={"checkbox-three-elem" + (isRightValue == null ? " nothing-chosen" : " ")}
                                onClick={() => checkboxConnectorHandler(null)}
                            >
                                <p>Нічого</p>
                            </div>
                        </div>
                    </ConnectorFormField>

                    <ConnectorFormField
                        fieldKey="points"
                        visible={connectorFormEntities.points.visible}
                        editing={connectorConfig}
                        label={connectorFormEntities.points.name}
                        onToggleVisibility={visibilityConnectorFields}
                    >
                        <input
                            name="answer-connector-points"
                            style={{ maxWidth: 70 }}
                            className="form-element-conn"
                            value={pointValue}
                            type="number"
                            onChange={inputPointsChangeHandler}
                        />
                    </ConnectorFormField>

                    <ConnectorFormField
                        fieldKey="url"
                        visible={connectorFormEntities.url.visible}
                        editing={connectorConfig}
                        label={connectorFormEntities.url.name}
                        onToggleVisibility={visibilityConnectorFields}
                    >
                        <input
                            name="answer-connector-url"
                            className="form-element-conn"
                            placeholder="https://..."
                            value={urlValue}
                            onChange={urlInputChangeHandler}
                        />
                    </ConnectorFormField>

                    <ConnectorFormField
                        fieldKey="estimationGroup"
                        visible={connectorFormEntities.estimationGroup.visible}
                        editing={connectorConfig}
                        label={connectorFormEntities.estimationGroup.name}
                        onToggleVisibility={visibilityConnectorFields}
                    >
                        <select name="group" onChange={selectEsGroupChangeHandler}>
                            <option value={null}></option>
                            {estimationGroups &&
                                estimationGroups.map((group) => (
                                    <option key={group.id} value={group.id}>
                                        {group.name}
                                    </option>
                                ))}
                        </select>
                    </ConnectorFormField>

                    <ConnectorFormField
                        fieldKey="stage"
                        visible={connectorFormEntities.stage.visible}
                        editing={connectorConfig}
                        label={connectorFormEntities.stage.name}
                        onToggleVisibility={visibilityConnectorFields}
                    >
                        <select name="stage" onChange={selectStageChangeHandler}>
                            <option value={null}></option>
                            {stages &&
                                stages.map((stage) => (
                                    <option key={stage.id} value={stage.id}>
                                        {stage.name}
                                    </option>
                                ))}
                        </select>
                    </ConnectorFormField>
                </div>

                <div className="add-answer-connector-options">
                    <div
                        className={`add-connector-option ${connectorTypeChosen == null ? "chosen-connector-type" : ""}`}
                        onClick={() => choseConnectorHandler(null)}
                    >
                        <IconButton fillColor="icon-teel" style={{ height: 30, width: 30 }} />
                    </div>

                    <div
                        className={`add-connector-option ${connectorTypeChosen == 1 ? "chosen-connector-type" : ""}`}
                        onClick={() => choseConnectorHandler(1)}
                    >
                        <IconKeys fillColor="icon-teel" style={{ height: 30, width: 30 }} />
                    </div>

                    <div className="connector-from-field-entity-hiden-container">
                        {connectorConfig
                            ? Object.keys(connectorFormEntities).map((key) =>
                                  connectorFormEntities[key].visible === false ? (
                                      <div
                                          className="connector-from-field-entity-hiden"
                                          key={key}
                                          onClick={() => visibilityConnectorFields(key)}
                                      >
                                          <IconVisibleOff fillColor="icon-orange" style={{ height: 20, width: 20 }} />
                                          <p>{connectorFormEntities[key].name}</p>
                                      </div>
                                  ) : (
                                      ""
                                  )
                              )
                            : ""}
                    </div>
                </div>
            </div>

            {isVisibleChangeConnectorButton ? (
                <div className="save-changed-connector-btn" onClick={saveConnector}>
                    <IconSave fillColor="icon-green" style={{ height: 40, width: 40 }} />
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
